/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', () => {
    // Select all accordion containers
    const accordions = document.querySelectorAll('.wp-block-create-block-moo-accordion');

    accordions.forEach((accordion) => {
        // Force the first item to be open if data-first-open-default is "true"
        if (accordion.dataset.firstOpenDefault === 'true') {
            const firstDetails = accordion.querySelector('details');
            if (firstDetails) {
                firstDetails.open = true;
            }
        }

        // Check if the accordion has the data-close-adjacent-item attribute set to "true"
        if (accordion.dataset.closeAdjacentItem === 'true') {
            const detailsElements = accordion.querySelectorAll('details');

            detailsElements.forEach((details) => {
                details.addEventListener('toggle', () => {
                    // If the current <details> is open, close all others
                    if (details.open) {
                        detailsElements.forEach((otherDetails) => {
                            if (otherDetails !== details) {
                                otherDetails.open = false;
                            }
                        });
                    }
                });
            });
        }
    });
});

